export default {
    props: {
    },
    data() {
        return {
        };
    },
    watch: {},
    created() {
    },
    methods: {
        up() {
            this.$eventHub.$emit('updateSort', this.block.public_id, 'up');
        },
        down() {
            this.$eventHub.$emit('updateSort', this.block.public_id, 'down');
        },
    }
};